import { useEffect } from "react";
import type { DialerSessionView } from "@gioia365/contracts";
import { Button } from "../design/components/Button";
import { Dialog } from "../design/components/Dialog";
import { useT } from "../i18n/locale";
import { callsWord } from "../leads/card/sequence-texts";
import { useDialerSession } from "./dialer-session";

// «Lead successivo» con un tentativo della sequenza ancora da finire (piano M5, R2; mock-up `scheda-lead.html`, `m-next`; il
// Commerciale decide, product owner 27 settembre 2026): «Resta su questa scheda» non avanza, «Apri il Lead successivo» chiude il
// tentativo con le chiamate fatte (`passOver`). Le chiamate fatte si dicono a parole, come `callsWord` del mock-up («una
// chiamata»), e sotto c'è la nota sulla chiamata che manca, che resta «Non fatta» con il nome di chi passa oltre (Task 12).

type Props = {
  pending: NonNullable<DialerSessionView["attemptPending"]>;
  onClose: () => void;
};

export function NextLeadDialog({ pending, onClose }: Props) {
  const t = useT();
  const { hold, next, busy } = useDialerSession();

  useEffect(() => hold(), [hold]);
  const missing = pending.required - pending.made;

  async function go() {
    onClose();
    await next({ passOver: true });
  }

  return (
    <Dialog
      open
      title={t("dialer.nextTitle")}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>{t("dialer.stay")}</Button>
          <Button variant="primary" disabled={busy} onClick={() => void go()}>
            {t("dialer.openNext")}
          </Button>
        </>
      }
    >
      <p>
        {t("dialer.attemptPending", {
          n: pending.attempt,
          made: callsWord(t, pending.made),
          required: pending.required,
        })}
      </p>
      {missing > 0 ? <p className="g-dialer-dialog__note">{missing === 1 ? t("dialer.attemptPendingNote") : t("dialer.attemptPendingNoteMany")}</p> : null}
    </Dialog>
  );
}
